import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.CatalogItemDetailsCart'

export default defineMessages({
  quantityAriaLabel: {
    id: `${scope}.quantityAriaLabel`,
    defaultMessage: 'Item quantity',
  },
  estimatedTotal: {
    id: `${scope}.estimatedTotal`,
    defaultMessage: 'Estimated total',
  },
  addToRequestButton: {
    id: `${scope}.addToRequestButton`,
    defaultMessage: 'Add to my request',
  },
})
